'use client';

import '@tanstack/react-query';

declare module '@tanstack/react-query' {
  interface Register {
    defaultError: ErrorWithFriendlyMessage;
  }
}

interface ErrorMessage {
  [key: string]: string[] | undefined;
}

export class ErrorWithFriendlyMessage extends Error {
  readonly detail?: string | null;
  readonly errors?: ErrorMessage | null;
  readonly title: string;
  readonly type?: string | null;

  constructor(options: { detail?: string | null; errors?: ErrorMessage | null; title: string; type?: string | null }) {
    super();
    this.detail = options.detail;
    this.errors = options.errors;
    this.title = options.title;
    this.type = options.type;
  }
}
